<div class="status">
  <div class="content-logo">
    <img alt="logo" proLogoImg class="content-logo__logo" />
  </div>
  <div>
    <div class="content">
      <div class="content__header">
        <p><mat-icon class="content__header--icon">description</mat-icon></p>
        <p class="content__header--title">{{ titleMessage }}</p>
        <p class="content__header--description">
          {{ sectionMessage }}
        </p>
      </div>
      <div>
        <ul>
          <li class="content__list">
            <div class="content__list--all">
              <div>
                <p class="content__list--step-title">{{ 'signaturit_pro.signature-status.document' |
                  translate:_transParam }}</p>
                <p class="content__list--step-description">
                  {{ documentName }}
                </p>
              </div>
            </div>
          </li>
          <li class="content__list">
            <div class="content__list--all">
              <div>
                <p class="content__list--step-title">{{ 'signaturit_pro.signature-status.sentby' | translate:_transParam
                  }}</p>
                <p class="content__list--step-description">{{ name }}</p>
              </div>
            </div>
          </li>
          <li class="content__list">
            <div class="content__list--all">
              <div>
                <p class="content__list--step-title">{{ 'signaturit_pro.signature-status.email' | translate:_transParam
                  }}</p>
                <p class="content__list--step-description">
                  <a href="mailto:{{ email }}">{{ email }}</a>
                </p>
              </div>
            </div>
          </li>
          <li class="content__list" *ngIf="shouldShowList()">
            <div class="content__list--all">
              <div>
                <p class="content__list--step-title">{{ message }}</p>
                <p class="content__list--step-description">
                  {{ signDate }}
                </p>
              </div>
            </div>
          </li>
          <li class="content__list">
            <div class="content__list--all">
              <div>
                <p class="content__list--step-title">{{ 'signaturit_pro.signature-status.state' | translate:_transParam
                  }}</p>
                <p class="content__list--step-description">
                  {{ state | translate:_transParam }}
                </p>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="content__footer">
        <mat-icon class="content__footer--icon-info">info</mat-icon>
        <p class="content__footer--body">
          {{ 'signaturit_pro.signature-status.footer' | translate:_transParam }}
          <a href="mailto:{{ email }}">{{ email }}</a>
        </p>
      </div>
    </div>
    <div class="content-exit">
      <button *ngIf="!isPublic" mat-button class="content-exit--button" (click)="exitProcess()">{{
        'signaturit_pro.general.go_dashboard' | translate:_transParam }}</button>
    </div>
  </div>
</div>
